let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e7Cip")).then(() => parcelRequire('2lNkg'));